module.exports = __webpack_public_path__ + "static/media/per-mu-ta-tions.de8315b3.txt";